import { Alert, Box } from '@mui/material';
import { useQuery } from 'react-query';
import { If } from 'src/components/If';
import { PanelLogin } from 'src/components/PanelLogin';
import { useAuthContext } from 'src/context/AuthContextProvider';
import { getDebenturesAssetData } from 'src/services/operation/operationDebentures';

import AssetMaturityRange from './AssetMaturityRange';
import AssetPrepayments from './AssetPrepayments';
import AssetReceivables from './AssetReceivables';

type OperationDebenturesAssetProps = {
  hashId: string;
};

export default function OperationDebenturesAsset({
  hashId,
}: OperationDebenturesAssetProps) {
  const { auth } = useAuthContext();
  const canViewAsset = Boolean(
    auth?.user?.subscription?.plan?.permissions?.operacoes_debentures_ativo,
  );

  const { data, isError, isLoading } = useQuery({
    queryKey: ['debenturesAsset', hashId],
    queryFn: () => getDebenturesAssetData(hashId),
    enabled: !!hashId && canViewAsset,
    retry: false,
  });

  return (
    <Box p={2}>
      <If condition={!canViewAsset}>
        <PanelLogin />
      </If>
      <If condition={canViewAsset}>
        <If condition={isError && !isLoading}>
          <Alert severity="warning">
            Não foi possível carregar os dados de ativo desta debênture.
          </Alert>
        </If>
        <If condition={!isError}>
          <AssetReceivables data={data} isLoading={isLoading} />
          <AssetMaturityRange data={data} isLoading={isLoading} />
          <AssetPrepayments data={data} isLoading={isLoading} />
        </If>
      </If>
    </Box>
  );
}
